import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContexto";

export default function SessionExpiredModal() {
  const { showLogoutModal, cerrarSesion } = useContext(AuthContext);

  if (!showLogoutModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl p-6 w-full max-w-sm mx-4 border border-slate-200 dark:border-slate-700">
        <h2 className="text-lg font-semibold text-center text-slate-800 dark:text-slate-100">
          🔒 Sesión expirada
        </h2>

        <p className="mt-3 text-sm text-center text-slate-600 dark:text-slate-300">
          Tu sesión ha expirado por seguridad.  
          Por favor inicia sesión nuevamente.
        </p>

        <button
          onClick={cerrarSesion}
          className="mt-5 w-full py-2 rounded-lg bg-amber-500 hover:bg-amber-600 text-white font-semibold transition-colors"
        >
          Ir al login
        </button>
      </div>
    </div>
  );
}
